import { loadStore, saveStore } from "../storage";
import { scoreFromEvents } from "../game/scoring";
import { MIN_DECISION_MS, WALK_MS } from "../game/config";
import { dailySeedString, utcDateISO } from "../rng";
import type { SubmitPayload } from "../types";

export { loadStore, saveStore };

export function scoreFromEventsSafe(payload: SubmitPayload): { ok: boolean; score?: number; error?: string } {
  if (payload.game !== "fact-trail") return { ok: false, error: "Wrong game." };
  const events = payload.events || [];
  if (payload.mode === "daily") {
    const expect = dailySeedString(utcDateISO(), payload.grade);
    if (payload.seed !== expect) return { ok: false, error: "Daily seed does not match today." };
  }
  const decisions = events.filter((e) => true);
  if (decisions.length) {
    const span = payload.timeMs;
    const walks = events.filter((e) => e.ok).length * WALK_MS;
    const avg = decisions.length ? (span - walks) / decisions.length : 9999;
    if (payload.finished && avg < MIN_DECISION_MS) {
      return { ok: false, error: "Timing looks impossible." };
    }
  }
  const br = scoreFromEvents(events, {
    finished: payload.finished,
    pathLength: payload.pathLength,
    secondsLeft: payload.timeLeftMs / 1000,
    timeMs: payload.timeMs,
  });
  return { ok: true, score: br.total };
}
